'use client';

import React__default from 'react';
import SingleRadio from '../../SingleRadio/index.js';
import { t } from '../../Utils/helpers.js';
import styles from '../JobAlert.module.scss.js';

var NotificationBy = function (_a) {
    var _b = _a.alertId, alertId = _b === void 0 ? '' : _b, _c = _a.language, language = _c === void 0 ? 'en' : _c, setJobNotificationBy = _a.setJobNotificationBy, jobNotificationBy = _a.jobNotificationBy;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("label", null, t('Notify via', language)),
        React__default.createElement("div", null,
            React__default.createElement("div", { className: styles.colSmall4 },
                React__default.createElement(SingleRadio, { id: 'notifications_by-radio-1', label: t('Email', language), onChange: function () { return setJobNotificationBy && setJobNotificationBy(1); }, name: "notifications_by-".concat(alertId), checked: jobNotificationBy === 1, isLeftRadio: true })),
            React__default.createElement("div", { className: styles.colSmall4 },
                React__default.createElement(SingleRadio, { id: 'notifications_by-radio-2', label: t('App', language), onChange: function () { return setJobNotificationBy && setJobNotificationBy(2); }, name: "notifications_by-".concat(alertId), checked: jobNotificationBy === 2, isLeftRadio: true })),
            React__default.createElement("div", { className: styles.colSmall4 },
                React__default.createElement(SingleRadio, { id: 'notifications_by-radio-3', label: t('Both', language), onChange: function () { return setJobNotificationBy && setJobNotificationBy(3); }, name: "notifications_by-".concat(alertId), checked: jobNotificationBy === 3, isLeftRadio: true })))));
};

export { NotificationBy as default };
//# sourceMappingURL=index.js.map
